import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
  } from "@/components/ui/table";
  import { Checkbox } from "@/components/ui/checkbox";
  import { Button } from "@/components/ui/button";
  import { MoreVertical } from "lucide-react";
  import {
    Tooltip,
    TooltipContent,
    TooltipTrigger,
  } from "@/components/ui/tooltip";
  
  type TableSkeletonProps = {
    /** Number of skeleton rows (default: 10) */
    rows?: number;
    /** Number of data columns (not counting checkbox/actions) */
    columns?: number;
    showCheckbox?: boolean;
    showActions?: boolean;
    className?: string;
  };
  
  export function TableSkeleton({
    rows = 10,
    columns = 5,
    showCheckbox = false,
    showActions = false,
    className,
  }: TableSkeletonProps) {
  // Vary widths so the shimmer looks natural across wide tables (e.g. Patients).
  const headerWidthClasses = [
    "w-16",
    "w-20",
    "w-24",
    "w-28",
    "w-32",
    "w-36",
    "w-40",
    "w-44",
  ];
  const cellWidthClasses = [
    "w-20",
    "w-24",
    "w-28",
    "w-32",
    "w-36",
    "w-40",
    "w-48",
    "w-56",
  ];

    return (
      <div className={className}>
        <Table>
          <TableHeader className=" ">
            <TableRow className="border-grey">
              {showCheckbox && (
                <TableHead className="w-12">
                  <Checkbox disabled />
                </TableHead>
              )}
              {Array.from({ length: columns }).map((_, i) => (
              <TableHead key={i} className="font-semibold py-4 min-w-0">
                <div
                  className={[
                    "h-4 bg-gray-200 rounded-full animate-pulse max-w-full",
                    headerWidthClasses[i % headerWidthClasses.length],
                  ].join(" ")}
                />
                </TableHead>
              ))}
              {showActions && (
                <TableHead className="font-semibold sticky right-0 bg-white w-[1%]">
                  Actions
                </TableHead>
              )}
            </TableRow>
          </TableHeader>
          <TableBody>
            {Array.from({ length: rows }).map((_, rowIndex) => (
              <TableRow key={rowIndex}>
                {showCheckbox && (
                  <TableCell className="w-12">
                    <Checkbox disabled />
                  </TableCell>
                )}
                {Array.from({ length: columns }).map((_, colIndex) => (
                <TableCell key={colIndex} className="py-4 min-w-0">
                  <div
                    className={[
                      "h-4 bg-gray-300 rounded-full animate-pulse max-w-full",
                      cellWidthClasses[colIndex % cellWidthClasses.length],
                    ].join(" ")}
                  />
                  </TableCell>
                ))}
                {showActions && (
                  <TableCell className="sticky right-0 bg-white">
                    <Tooltip>
                      <TooltipTrigger asChild>
                        <Button variant="outline" size="sm" disabled className="gap-2">
                          <MoreVertical className="h-4 w-4" />
                        </Button>
                      </TooltipTrigger>
                      <TooltipContent />
                    </Tooltip>
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    );
  }